import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnonymousIntent } from 'src/app/models/venta-rapida/anonymous-intent.model';

@Component({
  selector: 'app-venta-rapida-no-results-card',
  templateUrl: './no-results-card.component.html',
  styleUrls: ['./no-results-card.component.scss'],
  standalone: false
})
export class NoResultsCardComponent {
  @Input({ required: true }) query!: string;
  @Input({ required: true }) queryKind!: 'dni' | 'name';

  @Output() anonymousChosen = new EventEmitter<AnonymousIntent>();

  onUseAsTyped(): void {
    const intent: AnonymousIntent =
      this.queryKind === 'dni'
        ? { kind: 'dni', value: this.query }
        : { kind: 'name', value: this.query };
    this.anonymousChosen.emit(intent);
  }

  onFullAnonymous(): void {
    this.anonymousChosen.emit({ kind: 'full-anonymous' });
  }
}
